import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { green, grey, amber } from '@mui/material/colors';

// Create a theme instance with Martinique-inspired colors
let theme = createTheme({
  palette: {
    primary: {
      main: '#1c4880', // Blue from Martinique flag
      light: '#4671b0',
      dark: '#002553',
      contrastText: '#fff',
    },
    secondary: {
      main: amber[700], // Golden amber for Caribbean sun
      light: amber[500],
      dark: amber[900],
      contrastText: '#000',
    },
    success: {
      main: green[600], // Representing the lush vegetation
      light: green[400],
      dark: green[800],
    },
    background: {
      default: '#f8f8f8',
      paper: '#ffffff',
    },
    text: {
      primary: grey[900],
      secondary: grey[600], // Lighter shade for better readability
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
          overflow: 'hidden',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

// Apply responsive font sizes to all typography variants
theme = responsiveFontSizes(theme);

export default theme;
